import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import './styles/navigation.css';
import logo from './styles/images/mainlogo.png';
import dark_logo from './styles/images/mainlogo-black.png';
import pca from './styles/images/PCA-white.png';
import Hand from './styles/images/Hand-white.png';
import "aos/dist/aos.css";
import AOS from "aos";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileCareersOpen, setMobileCareersOpen] = useState(false);
  const timeoutRef = useRef(null);
  const careersRef = useRef(null);

  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease', once: false });
  }, []);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setIsOpen(false);
    setMobileServicesOpen(false);
    setMobileCareersOpen(false);
  }, [location.pathname]);

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  // Close on Escape / when resizing up to desktop
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setIsOpen(false);
    const onResize = () => window.innerWidth > 1024 && setIsOpen(false);
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const isHome = location.pathname === '/';
  const getLogo = () => (isHome ? logo : dark_logo);
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  const pathname = window.location.pathname === '/quil';

  const dashboardPath = ['/dashboard', '/dashboard/employee', '/dashboard/schedule', '/dashboard/payroll', '/hr/dashboard', '/hr/dashboard/profile', '/apply-hr', '/login', '/sign-up', '/hr/form', '/hr/form/'];
  const isDashboard = dashboardPath.includes(window.location.pathname);

  const isDashboardRoute = dashboardPath.some(route =>
    route === location.pathname || location.pathname.startsWith(route + '/')
  );

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsDropdownOpen(false), 1000);
  };

  const handleRouting = () => {
    try {
      const password = "samah123";
      const result = window.prompt("Please enter the password to access the careers page:");
      if (result === password) {
        window.location.href = "/quil";
      } else if (result !== null) {
        alert("Incorrect password. Access denied.");
      }
    } catch (error) {
      console.error("Error occurred while handling routing:", error);
    }
  };

  if (isDashboardRoute) return null;

  return (
    <>
      <nav
        className={`${pathname ? 'True' : 'False'} navbar1 ${isDashboard ? 'display-none' : ''} ${isHome ? 'on-home' : 'on-page'} ${isScrolled ? 'scrolled' : ''}`}
      >
        <div className="navbar-container">
          {/* Logo */}
          <a href="/" className="navbar-logo">
            <img src={getLogo()} alt="Logo" data-aos="fade-right" />
          </a>

          {/* Hamburger */}
          <button
            type="button"
            className={`hamburger ${isOpen ? "is-active" : ""}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Navigation Links / Mobile top-down menu */}
          <ul className={`nav-links ${isOpen ? "active" : ""}`}>
            {/* Mobile header: logo + close */}
            <li className="drawer-header" style={{ "--i": 0 }}>
              <a href="/" className="drawer-logo">
                <img src={logo} alt="Samah Home Care" />
              </a>
              <button
                type="button"
                className="drawer-close"
                onClick={() => setIsOpen(false)}
                aria-label="Close menu"
              >
                <span></span>
                <span></span>
              </button>
            </li>

            {/* Services */}
            <li
              id="nav-links"
              className={`has-sub ${mobileServicesOpen ? "open" : ""} ${isActive('/service') ? 'current' : ''}`}
              style={{ "--i": 1 }}
            >
              <div className="nav-row">
                <span className="nav-index">01</span>
                <a href="/service">Services</a>
                <button
                  type="button"
                  className="sub-toggle"
                  onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                  aria-label="Toggle services menu"
                  aria-expanded={mobileServicesOpen}
                >
                  <i className="fa fa-plus"></i>
                </button>
              </div>
              <ul className="sub-links">
                <div className="main2212">
                  <div className="CFSS">
                    <div className="CFss-logo">
                      <img src={Hand} alt="Hand Care" id="Animated" />
                      <h3>CFSS</h3>
                    </div>
                    <div className="CFSS-text">
                      <p>
                        Community First Services and Supports (CFSS) – Providing personalized home care services to help individuals maintain independence and improve their quality of life.
                      </p>
                      <a href="/service/CFSS" className="nav-link" style={{color:'#58afe8'}}>Learn More <i className="fa fa-arrow-right"></i></a>
                    </div>
                  </div>
                  <div className="CFSS">
                    <div className="CFss-logo">
                      <img src={pca} alt="PCA" id="Animated" />
                      <h3>PCA</h3>
                    </div>
                    <div className="CFSS-text">
                      <p>
                        Personal Care Assistance (PCA) – Offering compassionate in-home support to help individuals with daily activities, ensuring comfort, safety, and independence.
                      </p>
                      <a href="/service/PCA" className="nav-link" style={{color:'#58afe8'}}>Learn More <i className="fa fa-arrow-right"></i></a>
                    </div>
                  </div>
                </div>

                <div className="QuickLinks112">
                  <h4>Quick Links</h4>
                  <li><a href="/Resource/evv"><i className="fa fa-arrow-right"></i> EVV</a></li>
                  <li><a href="/Resource/FAQ"><i className="fa fa-arrow-right"></i> Knowledge Based</a></li>
                </div>
              </ul>
            </li>

            {/* Careers */}
            <li
              id="nav-links"
              ref={careersRef}
              className={`has-sub careers-item ${mobileCareersOpen ? "open" : ""} ${isActive('/career') ? 'current' : ''}`}
              style={{ "--i": 2 }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="nav-row">
                <span className="nav-index">02</span>
                <a href="/career">Careers</a>
                <button
                  type="button"
                  className="sub-toggle"
                  onClick={() => setMobileCareersOpen(!mobileCareersOpen)}
                  aria-label="Toggle careers menu"
                  aria-expanded={mobileCareersOpen}
                >
                  <i className="fa fa-plus"></i>
                </button>
              </div>
              <div className="mobile-careers">
                <div className="mobile-careers-card">
                  <h3>Join Our Team</h3>
                  <p>Competitive pay, flexible schedules, and a supportive work environment.</p>
                  <a onClick={handleRouting} className="nav-link apply-btn">Apply Now <i className="fa fa-arrow-right"></i></a>
                </div>
              </div>
            </li>

            <li id="nav-links" className={isActive('/why-samah-homes') ? 'current' : ''} style={{ "--i": 3 }}>
              <div className="nav-row">
                <span className="nav-index">03</span>
                <a href="/why-samah-homes">Why Samah Home Care</a>
              </div>
            </li>
            <li id="nav-links" className={isActive('/covid-19') ? 'current' : ''} style={{ "--i": 4 }}>
              <div className="nav-row">
                <span className="nav-index">04</span>
                <a href="/covid-19">Covid-19</a>
              </div>
            </li>
            <li id="nav-links" className={isActive('/contact-us') ? 'current' : ''} style={{ "--i": 5 }}>
              <div className="nav-row">
                <span className="nav-index">05</span>
                <a href="/contact-us">Contact Us</a>
              </div>
            </li>

            <li className="nav0cta" style={{ "--i": 6 }}>
              <a href="/Refferal-form" className="link-refferal" style={{ textDecoration: "none" }}>
                Get Appointment
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Global Careers Dropdown (desktop only) */}
      {isDropdownOpen && careersRef.current && (
        <div
          className="careers-dropdown-global"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{
            position: 'fixed',
            top: careersRef.current.getBoundingClientRect().bottom + 10,
            left: careersRef.current.getBoundingClientRect().left - 10,
            zIndex: 9999,
          }}
        >
          <ul className="sub-links">
            <div className="main2212">
              <div className="CFSS">
                <div className="CFss-logo">
                  <h3>Join Our Team</h3>
                </div>
                <div className="CFSS-text">
                  <p>Start your career with Samah Home Care. We offer competitive pay, flexible schedules, and a supportive work environment.</p>
                  <a onClick={handleRouting} className="nav-link" style={{ cursor: 'pointer' }}>Apply Now</a>
                </div>
              </div>
            </div>
          </ul>
        </div>
      )}
    </>
  );
};

export default Navbar;